module.exports = "/_next/static/images/home-payroll-2ac0b146c93df8ac3db17332a3b0f228.png";